import {
  panelLabelArchive,
  panelLabelCodici,
  panelLabelPrivate,
  panelLabelSources,
} from "_constants";

export const DetailPanelSourcesContainer = ({
  codesTotal,
  archivesTotal,
  privatesTotal,
}: {
  codesTotal: number;
  archivesTotal: number;
  privatesTotal: number;
}) => {
  return (
    <div className="detail-panel-info-container">
      <div>
        <span className="text text-bold">{panelLabelSources}</span>
      </div>
      <div className="margin-top-8 flex-container align-center gap-28">
        <div className="flex-container gap-6">
          <span className="round-source"></span>
          <span
            className={`${codesTotal > 0 ? "" : "opacity-20"} blue text-bold`}
          >
            {panelLabelCodici} ({codesTotal})
          </span>
        </div>
        <div className="flex-container gap-6">
          <span className="round-source archive"></span>
          <span
            className={`${
              archivesTotal > 0 ? "" : "opacity-20"
            } blue text-bold`}
          >
            {panelLabelArchive} ({archivesTotal})
          </span>
        </div>
        <div className="flex-container gap-6">
          <span className="round-source private"></span>
          <span
            className={`${
              privatesTotal > 0 ? "" : "opacity-20"
            } blue text-bold`}
          >
            {panelLabelPrivate} ({privatesTotal})
          </span>
        </div>
      </div>
    </div>
  );
};
